export default __webpack_public_path__ + "static/media/gwn09.b473f833.webp";